export const footerLinks = {
  'fr-ru': [
    {
      title: 'Популярные направления',
      items: [
        {
          href: 'https://www.wingie.fr/flights/to-moscow/',
          title: 'Москва',
        },
        {
          href: 'https://www.wingie.fr/flights/to-vladivostok/',
          title: 'Владивосток',
        },
        {
          href: 'https://www.wingie.fr/flights/to-krasnodar/',
          title: 'Краснодар',
        },
        {
          href: 'https://www.wingie.fr/flights/to-new-york/',
          title: 'Нью-Йорк',
        },
        {
          href: 'https://www.wingie.fr/flights/to-london/',
          title: 'Лондон',
        },
        {
          href: 'https://www.wingie.fr/flights/to-amsterdam/',
          title: 'Амстердам',
        },
      ],
    },
    {
      title: 'Популярные страны',
      items: [
        {
          href: 'https://www.wingie.fr/flights/am-armenia/',
          title: 'Армения',
        },
        {
          href: 'https://www.wingie.fr/flights/az-azerbaijan/',
          title: 'Азербайджан',
        },
        {
          href: 'https://www.wingie.fr/flights/by-belarus/',
          title: 'Беларусь',
        },
        {
          href: 'https://www.wingie.fr/flights/eg-egypt/',
          title: 'Египет',
        },
        {
          href: 'https://www.wingie.fr/flights/ge-georgia/',
          title: 'Грузия',
        },
        {
          href: 'https://www.wingie.fr/flights/in-india/',
          title: 'Индия',
        },
      ],
    },
    {
      title: 'Популярные авиакомпании',
      items: [
        {
          href: 'https://www.wingie.fr/flights/airlines/azerbaijan-airlines/',
          title: 'Azerbaijan Airlines',
        },
        {
          href: 'https://www.wingie.fr/flights/airlines/pobeda/',
          title: 'Pobeda',
        },
        {
          href: 'https://www.wingie.fr/flights/airlines/nordwind-airlines/',
          title: 'Nordwind Airlines',
        },
        {
          href: 'https://www.wingie.fr/flights/airlines/rossiya-russian-airlines/',
          title: 'Rossiya-Russian Airlines',
        },
        {
          href: 'https://www.wingie.fr/flights/airlines/s7-airlines/',
          title: 'S7 Airlines',
        },
        {
          href: 'https://www.wingie.fr/flights/airlines/utair/',
          title: 'Utair',
        },
      ],
    },
  ],
  'fr-en': [
    {
      title: 'Top Destinations',
      items: [
        {
          href: 'https://www.wingie.fr/en/flights/to-moscow/',
          title: 'Moscow',
        },
        {
          href: 'https://www.wingie.fr/en/flights/to-vladivostok/',
          title: 'Vladivostok',
        },
        {
          href: 'https://www.wingie.fr/en/flights/to-krasnodar/',
          title: 'Krasnodar',
        },
        {
          href: 'https://www.wingie.fr/en/flights/to-new-york/',
          title: 'New York',
        },
        {
          href: 'https://www.wingie.fr/en/flights/to-london/',
          title: 'London',
        },
        {
          href: 'https://www.wingie.fr/en/flights/to-amsterdam/',
          title: 'Amsterdam',
        },
      ],
    },
    {
      title: 'Popular Countries',
      items: [
        {
          href: 'https://www.wingie.fr/en/flights/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://www.wingie.fr/en/flights/az-azerbaijan/',
          title: 'Azerbaijan',
        },
        {
          href: 'https://www.wingie.fr/en/flights/by-belarus/',
          title: 'Belarus',
        },
        {
          href: 'https://www.wingie.fr/en/flights/eg-egypt/',
          title: 'Egypt',
        },
        {
          href: 'https://www.wingie.fr/en/flights/ge-georgia/',
          title: 'Georgia',
        },
        {
          href: 'https://www.wingie.fr/en/flights/in-india/',
          title: 'India',
        },
      ],
    },
    {
      title: 'Popular Airlines',
      items: [
        {
          href: 'https://www.wingie.fr/en/flights/airlines/azerbaijan-airlines/',
          title: 'Azerbaijan Airlines',
        },
        {
          href: 'https://www.wingie.fr/en/flights/airlines/pobeda/',
          title: 'Pobeda',
        },
        {
          href: 'https://www.wingie.fr/en/flights/airlines/nordwind-airlines/',
          title: 'Nordwind Airlines',
        },
        {
          href: 'https://www.wingie.fr/en/flights/airlines/rossiya-russian-airlines/',
          title: 'Rossiya-Russian Airlines',
        },
        {
          href: 'https://www.wingie.fr/en/flights/airlines/s7-airlines/',
          title: 'S7 Airlines',
        },
        {
          href: 'https://www.wingie.fr/en/flights/airlines/utair/',
          title: 'Utair',
        },
      ],
    },
  ],
  'fr-es': [
    {
      title: 'Principales destinos',
      items: [
        {
          href: 'https://www.wingie.fr/es/vuelos/a-moscow/',
          title: 'Moscow',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/a-vladivostok/',
          title: 'Vladivostok',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/a-krasnodar/',
          title: 'Krasnodar',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/a-new-york/',
          title: 'New York',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/a-london/',
          title: 'London',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/a-amsterdam/',
          title: 'Amsterdam',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://www.wingie.fr/es/vuelos/am-armenia/',
          title: 'Armenia',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/az-azerbaijan/',
          title: 'Azerbaiyán',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/by-belarus/',
          title: 'Bielorrusia',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/eg-egypt/',
          title: 'Egipto',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/ge-georgia/',
          title: 'Georgia',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/in-india/',
          title: 'India',
        },
      ],
    },
    {
      title: 'Aerolíneas populares',
      items: [
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/azerbaijan-airlines/',
          title: 'Azerbaijan Airlines',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/pobeda/',
          title: 'Pobeda',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/nordwind-airlines/',
          title: 'Nordwind Airlines',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/rossiya-russian-airlines/',
          title: 'Rossiya-Russian Airlines',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/s7-airlines/',
          title: 'S7 Airlines',
        },
        {
          href: 'https://www.wingie.fr/es/vuelos/companias-aereas/utair/',
          title: 'Utair',
        },
      ],
    },
  ],
  'fr-de': [
    {
      title: 'Top-Destinationen',
      items: [
        {
          href: 'https://www.wingie.fr/de/flug/nach-moskau/',
          title: 'Moskau',
        },
        {
          href: 'https://www.wingie.fr/de/flug/nach-wladiwostok/',
          title: 'Wladiwostok',
        },
        {
          href: 'https://www.wingie.fr/de/flug/nach-krasnodar/',
          title: 'Krasnodar',
        },
        {
          href: 'https://www.wingie.fr/de/flug/nach-new-york/',
          title: 'New York',
        },
        {
          href: 'https://www.wingie.fr/de/flug/nach-london/',
          title: 'London',
        },
        {
          href: 'https://www.wingie.fr/de/flug/nach-amsterdam/',
          title: 'Amsterdam',
        },
      ],
    },
    {
      title: 'Beliebte Länder',
      items: [
        {
          href: 'https://www.wingie.fr/de/flug/am-armenien/',
          title: 'Armenien',
        },
        {
          href: 'https://www.wingie.fr/de/flug/az-aserbaidschan/',
          title: 'Aserbaidschan',
        },
        {
          href: 'https://www.wingie.fr/de/flug/by-weissrussland/',
          title: 'Weißrussland',
        },
        {
          href: 'https://www.wingie.fr/de/flug/eg-aegypten/',
          title: 'Ägypten',
        },
        {
          href: 'https://www.wingie.fr/de/flug/ge-georgien/',
          title: 'Georgien',
        },
        {
          href: 'https://www.wingie.fr/de/flug/in-indien/',
          title: 'Indien',
        },
      ],
    },
    {
      title: 'Beliebte Fluggesellschaften',
      items: [
        {
          href: 'https://www.wingie.fr/de/flug/airlines/azerbaijan-airlines/',
          title: 'Azerbaijan Airlines',
        },
        {
          href: 'https://www.wingie.fr/de/flug/airlines/pobeda/',
          title: 'Pobeda',
        },
        {
          href: 'https://www.wingie.fr/de/flug/airlines/nordwind-airlines/',
          title: 'Nordwind Airlines',
        },
        {
          href: 'https://www.wingie.fr/de/flug/airlines/rossiya-russian-airlines/',
          title: 'Rossiya-Russian Airlines',
        },
        {
          href: 'https://www.wingie.fr/de/flug/airlines/s7-airlines/',
          title: 'S7 Airlines',
        },
        {
          href: 'https://www.wingie.fr/de/flug/airlines/utair/',
          title: 'Utair',
        },
      ],
    },
  ],
  'fr-ar': [
    {
      title: 'أفضل الوجهات',
      items: [
        {
          href: 'https://www.wingie.fr/ar/flights/to-moscow/',
          title: 'موسكو',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/to-vladivostok/',
          title: 'فلاديفوستوك',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/to-krasnodar/',
          title: 'كراسنودار',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/to-new-york/',
          title: 'نيويورك',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/to-london/',
          title: 'لندن',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/to-amsterdam/',
          title: 'أميستردام',
        },
      ],
    },
    {
      title: 'أشهر الدول',
      items: [
        {
          href: 'https://www.wingie.fr/ar/flights/am-armenia/',
          title: 'أرمينيا',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/az-azerbaijan/',
          title: 'أذربيجان',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/by-belarus/',
          title: 'بيلاروسيا',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/eg-egypt/',
          title: 'مصر',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/ge-georgia/',
          title: 'جورجيا',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/in-india/',
          title: 'الهند',
        },
      ],
    },
    {
      title: 'أشهر الخطوط الجوية',
      items: [
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/azerbaijan-airlines/',
          title: 'الخطوط الجوية الأذربي',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/pobeda/',
          title: 'بوبيدا',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/nordwind-airlines/',
          title: 'نورد ويند ايرلاينز',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/rossiya-russian-airlines/',
          title: 'Rossiya-Russian Airlines',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/s7-airlines/',
          title: 'الخطوط الجوية ال',
        },
        {
          href: 'https://www.wingie.fr/ar/flights/airlines/utair/',
          title: 'Utair',
        },
      ],
    },
  ],
  'fr-it': [
    {
      title: 'Principali destinazioni',
      items: [
        { href: 'https://www.wingie.fr/it/flights/to-moscow/', title: 'Mosca' },
        { href: 'https://www.wingie.fr/it/flights/to-vladivostok/', title: 'Vladivostok' },
        { href: 'https://www.wingie.fr/it/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/it/flights/to-new-york/', title: 'New York' },
        { href: 'https://www.wingie.fr/it/flights/to-london/', title: 'Londra' },
        { href: 'https://www.wingie.fr/it/flights/to-amsterdam/', title: 'Amsterdam' },
      ],
    },
    {
      title: 'Paesi popolari',
      items: [
        { href: 'https://www.wingie.fr/it/flights/am-armenia/', title: 'Armenia' },
        { href: 'https://www.wingie.fr/it/flights/az-azerbaijan/', title: 'Azerbaigian' },
        { href: 'https://www.wingie.fr/it/flights/by-belarus/', title: 'Bielorussia' },
        { href: 'https://www.wingie.fr/it/flights/eg-egypt/', title: 'Egitto' },
        { href: 'https://www.wingie.fr/it/flights/ge-georgia/', title: 'Georgia' },
        { href: 'https://www.wingie.fr/it/flights/in-india/', title: 'India' },
      ],
    },
    {
      title: 'Compagnie aeree popolari',
      items: [
        { href: 'https://www.wingie.fr/it/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/it/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/it/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/it/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/it/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/it/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-fr': [
    {
      title: 'Principales destinations',
      items: [
        { title: 'Las Vegas', href: 'https://www.wingie.fr/flights/to-las-vegas/' },
        { title: 'Chicago', href: 'https://www.wingie.fr/flights/to-chicago/' },
        { title: 'Miami', href: 'https://www.wingie.fr/flights/to-miami/' },
        { title: 'Cancún', href: 'https://www.wingie.fr/flights/to-cancun/' },
        { title: 'Londres', href: 'https://www.wingie.fr/flights/to-london/' },
        { title: 'Honolulu', href: 'https://www.wingie.fr/flights/to-honolulu/' },
      ],
    },
    {
      title: 'Pays populaires',
      items: [
        { title: 'Canada', href: 'https://www.wingie.fr/flights/ca-canada/' },
        { title: 'Chine', href: 'https://www.wingie.fr/flights/cn-china/' },
        { title: 'Costa Rica', href: 'https://www.wingie.fr/flights/cr-costa-rica/' },
        { title: 'République dominicaine', href: 'https://www.wingie.fr/flights/do-dominican-republic/' },
        { title: 'El Salvador', href: 'https://www.wingie.fr/flights/sv-el-salvador/' },
        { title: 'France', href: 'https://www.wingie.fr/flights/fr-france/' },
      ],
    },
    {
      title: 'Compagnies aériennes populaires',
      items: [
        { title: 'American Airlines', href: 'https://www.wingie.fr/flights/airlines/american-airlines/' },
        { title: 'Delta Air Lines', href: 'https://www.wingie.fr/flights/airlines/delta-air-lines/' },
        { title: 'United Airlines', href: 'https://www.wingie.fr/flights/airlines/united-airlines/' },
        { title: 'Alaska Airlines', href: 'https://www.wingie.fr/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/flights/airlines/jetblue/' },
        { title: 'Hawaiian Airlines', href: 'https://www.wingie.fr/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-pt': [
    {
      title: 'Principais destinos',
      items: [
        { href: 'https://www.wingie.fr/pt/flights/to-moscow/', title: 'Moscou' },
        { href: 'https://www.wingie.fr/pt/flights/to-vladivostok/', title: 'Vladivostok' },
        { href: 'https://www.wingie.fr/pt/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/pt/flights/to-new-york/', title: 'Nova York' },
        { href: 'https://www.wingie.fr/pt/flights/to-london/', title: 'Londres' },
        { href: 'https://www.wingie.fr/pt/flights/to-amsterdam/', title: 'Amsterdã' },
      ],
    },
    {
      title: 'Países populares',
      items: [
        { href: 'https://www.wingie.fr/pt/flights/am-armenia/', title: 'Armênia' },
        { href: 'https://www.wingie.fr/pt/flights/az-azerbaijan/', title: 'Azerbaijão' },
        { href: 'https://www.wingie.fr/pt/flights/by-belarus/', title: 'Bielorrússia' },
        { href: 'https://www.wingie.fr/pt/flights/eg-egypt/', title: 'Egito' },
        { href: 'https://www.wingie.fr/pt/flights/ge-georgia/', title: 'Geórgia' },
        { href: 'https://www.wingie.fr/pt/flights/in-india/', title: 'Índia' },
      ],
    },
    {
      title: 'Companhias aéreas populares',
      items: [
        { href: 'https://www.wingie.fr/pt/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/pt/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/pt/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/pt/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/pt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/pt/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-ro': [
    {
      title: 'Top destinații',
      items: [
        { href: 'https://www.wingie.fr/ro/flights/to-moscow/', title: 'Moscova' },
        { href: 'https://www.wingie.fr/ro/flights/to-vladivostok/', title: 'Vladivostok' },
        { href: 'https://www.wingie.fr/ro/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/ro/flights/to-new-york/', title: 'New York' },
        { href: 'https://www.wingie.fr/ro/flights/to-london/', title: 'Londra' },
        { href: 'https://www.wingie.fr/ro/flights/to-amsterdam/', title: 'Amsterdam' },
      ],
    },
    {
      title: 'Țări populare',
      items: [
        { href: 'https://www.wingie.fr/ro/flights/am-armenia/', title: 'Armenia' },
        { href: 'https://www.wingie.fr/ro/flights/az-azerbaijan/', title: 'Azerbaidjan' },
        { href: 'https://www.wingie.fr/ro/flights/by-belarus/', title: 'Belarus' },
        { href: 'https://www.wingie.fr/ro/flights/eg-egypt/', title: 'Egipt' },
        { href: 'https://www.wingie.fr/ro/flights/ge-georgia/', title: 'Georgia' },
        { href: 'https://www.wingie.fr/ro/flights/in-india/', title: 'India' },
      ],
    },
    {
      title: 'Companii aeriene populare',
      items: [
        { href: 'https://www.wingie.fr/ro/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/ro/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/ro/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/ro/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/ro/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/ro/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-pl': [
    {
      title: 'Najpopularniejsze kierunki',
      items: [
        { href: 'https://www.wingie.fr/pl/flights/to-moscow/', title: 'Moskwa' },
        { href: 'https://www.wingie.fr/pl/flights/to-vladivostok/', title: 'Władywostok' },
        { href: 'https://www.wingie.fr/pl/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/pl/flights/to-new-york/', title: 'Nowy Jork' },
        { href: 'https://www.wingie.fr/pl/flights/to-london/', title: 'Londyn' },
        { href: 'https://www.wingie.fr/pl/flights/to-amsterdam/', title: 'Amsterdam' },
      ],
    },
    {
      title: 'Popularne kraje',
      items: [
        { href: 'https://www.wingie.fr/pl/flights/am-armenia/', title: 'Armenia' },
        { href: 'https://www.wingie.fr/pl/flights/az-azerbaijan/', title: 'Azerbejdżan' },
        { href: 'https://www.wingie.fr/pl/flights/by-belarus/', title: 'Białoruś' },
        { href: 'https://www.wingie.fr/pl/flights/eg-egypt/', title: 'Egipt' },
        { href: 'https://www.wingie.fr/pl/flights/ge-georgia/', title: 'Gruzja' },
        { href: 'https://www.wingie.fr/pl/flights/in-india/', title: 'Indie' },
      ],
    },
    {
      title: 'Popularne linie lotnicze',
      items: [
        { href: 'https://www.wingie.fr/pl/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/pl/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/pl/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/pl/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/pl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/pl/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-lt': [
    {
      title: 'Populiariausi maršrutai',
      items: [
        { href: 'https://www.wingie.fr/lt/flights/to-moscow/', title: 'Maskva' },
        { href: 'https://www.wingie.fr/lt/flights/to-vladivostok/', title: 'Vladivostokas' },
        { href: 'https://www.wingie.fr/lt/flights/to-krasnodar/', title: 'Krasnodaris' },
        { href: 'https://www.wingie.fr/lt/flights/to-new-york/', title: 'Niujorkas' },
        { href: 'https://www.wingie.fr/lt/flights/to-london/', title: 'Londonas' },
        { href: 'https://www.wingie.fr/lt/flights/to-amsterdam/', title: 'Amsterdamas' },
      ],
    },
    {
      title: 'Populiarios šalys',
      items: [
        { href: 'https://www.wingie.fr/lt/flights/am-armenia/', title: 'Armėnija' },
        { href: 'https://www.wingie.fr/lt/flights/az-azerbaijan/', title: 'Azerbaidžanas' },
        { href: 'https://www.wingie.fr/lt/flights/by-belarus/', title: 'Baltarusija' },
        { href: 'https://www.wingie.fr/lt/flights/eg-egypt/', title: 'Egiptas' },
        { href: 'https://www.wingie.fr/lt/flights/ge-georgia/', title: 'Gruzija' },
        { href: 'https://www.wingie.fr/lt/flights/in-india/', title: 'Indija' },
      ],
    },
    {
      title: 'Populiarios oro linijos',
      items: [
        { href: 'https://www.wingie.fr/lt/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/lt/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/lt/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/lt/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/lt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/lt/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-uz': [
    {
      title: "Mashhur yo'nalishlar",
      items: [
        { href: 'https://www.wingie.fr/uz/flights/to-moscow/', title: 'Moskva' },
        { href: 'https://www.wingie.fr/uz/flights/to-vladivostok/', title: 'Vladivostok' },
        { href: 'https://www.wingie.fr/uz/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/uz/flights/to-new-york/', title: 'Nyu-York' },
        { href: 'https://www.wingie.fr/uz/flights/to-london/', title: 'London' },
        { href: 'https://www.wingie.fr/uz/flights/to-amsterdam/', title: 'Amsterdam' },
      ],
    },
    {
      title: 'Mashhur davlatlar',
      items: [
        { href: 'https://www.wingie.fr/uz/flights/am-armaniston/', title: 'Armaniston' },
        { href: 'https://www.wingie.fr/uz/flights/az-ozarbayjon/', title: 'Ozarbayjon' },
        { href: 'https://www.wingie.fr/uz/flights/by-belarus/', title: 'Belarus' },
        { href: 'https://www.wingie.fr/uz/flights/eg-misr/', title: 'Misr' },
        { href: 'https://www.wingie.fr/uz/flights/ge-gruziya/', title: 'Gruziya' },
        { href: 'https://www.wingie.fr/uz/flights/in-hindiston/', title: 'Hindiston' },
      ],
    },
    {
      title: 'Mashhur aviakompaniyalar',
      items: [
        { href: 'https://www.wingie.fr/uz/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/uz/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/uz/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/uz/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/uz/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/uz/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-sr': [
    {
      title: 'Популарне дестинације',
      items: [
        { href: 'https://www.wingie.fr/sr/flights/to-moscow/', title: 'Москва' },
        { href: 'https://www.wingie.fr/sr/flights/to-vladivostok/', title: 'Владивосток' },
        { href: 'https://www.wingie.fr/sr/flights/to-krasnodar/', title: 'Краснодар' },
        { href: 'https://www.wingie.fr/sr/flights/to-new-york/', title: 'Њујорк' },
        { href: 'https://www.wingie.fr/sr/flights/to-london/', title: 'Лондон' },
        { href: 'https://www.wingie.fr/sr/flights/to-amsterdam/', title: 'Амстердам' },
      ],
    },
    {
      title: 'Популарне земље',
      items: [
        { href: 'https://www.wingie.fr/sr/flights/am-jermenija/', title: 'Јерменија' },
        { href: 'https://www.wingie.fr/sr/flights/az-azerbejdzan/', title: 'Азербејџан' },
        { href: 'https://www.wingie.fr/sr/flights/by-belorusija/', title: 'Белорусија' },
        { href: 'https://www.wingie.fr/sr/flights/eg-egipat/', title: 'Египат' },
        { href: 'https://www.wingie.fr/sr/flights/ge-gruzija/', title: 'Грузија' },
        { href: 'https://www.wingie.fr/sr/flights/in-indija/', title: 'Индија' },
      ],
    },
    {
      title: 'Популарне авио-компаније',
      items: [
        { href: 'https://www.wingie.fr/sr/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/sr/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/sr/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/sr/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/sr/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/sr/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-ky': [
    {
      title: 'Популярдуу багыттар',
      items: [
        { href: 'https://www.wingie.fr/ky/учуштар/to-moscow/', title: 'Москва' },
        { href: 'https://www.wingie.fr/ky/учуштар/to-vladivostok/', title: 'Владивосток' },
        { href: 'https://www.wingie.fr/ky/учуштар/to-krasnodar/', title: 'Краснодар' },
        { href: 'https://www.wingie.fr/ky/учуштар/to-new-york/', title: 'Нью-Йорк' },
        { href: 'https://www.wingie.fr/ky/учуштар/to-london/', title: 'Лондон' },
        { href: 'https://www.wingie.fr/ky/учуштар/to-amsterdam/', title: 'Амстердам' },
      ],
    },
    {
      title: 'Популярдуу өлкөлөр',
      items: [
        { href: 'https://www.wingie.fr/ky/учуштар/am-armenya/', title: 'Армения' },
        { href: 'https://www.wingie.fr/ky/учуштар/az-azerbyzhan/', title: 'Азербайжан' },
        { href: 'https://www.wingie.fr/ky/учуштар/by-belarus/', title: 'Беларусь' },
        { href: 'https://www.wingie.fr/ky/учуштар/eg-mesir/', title: 'Мысыр' },
        { href: 'https://www.wingie.fr/ky/учуштар/ge-gruziya/', title: 'Грузия' },
        { href: 'https://www.wingie.fr/ky/учуштар/in-indya/', title: 'Индия' },
      ],
    },
    {
      title: 'Популярдуу авиакомпаниялар',
      items: [
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/ky/учуштар/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-tg': [
    {
      title: 'Самаратарин ҷоҳои сафар',
      items: [
        { href: 'https://www.wingie.fr/tg/flights/to-moskva/', title: 'Москва' },
        { href: 'https://www.wingie.fr/tg/flights/to-vladivostok/', title: 'Владивосток' },
        { href: 'https://www.wingie.fr/tg/flights/to-krasnodar/', title: 'Краснодар' },
        { href: 'https://www.wingie.fr/tg/flights/to-new-york/', title: 'Ню-Йорк' },
        { href: 'https://www.wingie.fr/tg/flights/to-london/', title: 'Лондон' },
        { href: 'https://www.wingie.fr/tg/flights/to-amsterdam/', title: 'Амстердам' },
      ],
    },
    {
      title: 'Кишварҳои машҳур',
      items: [
        { href: 'https://www.wingie.fr/tg/flights/am-armaniston/', title: 'Арманистон' },
        { href: 'https://www.wingie.fr/tg/flights/az-ozarboyzhon/', title: 'Озарбойҷон' },
        { href: 'https://www.wingie.fr/tg/flights/by-belarus/', title: 'Беларус' },
        { href: 'https://www.wingie.fr/tg/flights/eg-misr/', title: 'Миср' },
        { href: 'https://www.wingie.fr/tg/flights/ge-gruziya/', title: 'Гурҷистон' },
        { href: 'https://www.wingie.fr/tg/flights/in-hinduston/', title: 'Ҳиндустон' },
      ],
    },
    {
      title: 'Компанияҳои машҳури парвозӣ',
      items: [
        { href: 'https://www.wingie.fr/tg/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/tg/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/tg/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/tg/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/tg/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/tg/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-kk': [
    {
      title: 'Танымал бағыттар',
      items: [
        { href: 'https://www.wingie.fr/kk/flights/to-moscow/', title: 'Мәскеу' },
        { href: 'https://www.wingie.fr/kk/flights/to-vladivostok/', title: 'Владивосток' },
        { href: 'https://www.wingie.fr/kk/flights/to-krasnodar/', title: 'Краснодар' },
        { href: 'https://www.wingie.fr/kk/flights/to-new-york/', title: 'Нью-Йорк' },
        { href: 'https://www.wingie.fr/kk/flights/to-london/', title: 'Лондон' },
        { href: 'https://www.wingie.fr/kk/flights/to-amsterdam/', title: 'Амстердам' },
      ],
    },
    {
      title: 'Танымал елдер',
      items: [
        { href: 'https://www.wingie.fr/kk/flights/am-armenya/', title: 'Армения' },
        { href: 'https://www.wingie.fr/kk/flights/az-azerbyzhan/', title: 'Әзербайжан' },
        { href: 'https://www.wingie.fr/kk/flights/by-belarus/', title: 'Беларусь' },
        { href: 'https://www.wingie.fr/kk/flights/eg-mesir/', title: 'Мысыр' },
        { href: 'https://www.wingie.fr/kk/flights/ge-gruziya/', title: 'Грузия' },
        { href: 'https://www.wingie.fr/kk/flights/in-hindystan/', title: 'Үндістан' },
      ],
    },
    {
      title: 'Танымал авиакомпаниялар',
      items: [
        { href: 'https://www.wingie.fr/kk/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/kk/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/kk/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/kk/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/kk/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/kk/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-nl': [
    {
      title: 'Populaire bestemmingen',
      items: [
        { href: 'https://www.wingie.fr/nl/flights/to-moscow/', title: 'Moskou' },
        { href: 'https://www.wingie.fr/nl/flights/to-vladivostok/', title: 'Vladivostok' },
        { href: 'https://www.wingie.fr/nl/flights/to-krasnodar/', title: 'Krasnodar' },
        { href: 'https://www.wingie.fr/nl/flights/to-new-york/', title: 'New York' },
        { href: 'https://www.wingie.fr/nl/flights/to-london/', title: 'Londen' },
        { href: 'https://www.wingie.fr/nl/flights/to-amsterdam/', title: 'Amsterdam' },
      ],
    },
    {
      title: 'Populaire landen',
      items: [
        { href: 'https://www.wingie.fr/nl/flights/am-armenie/', title: 'Armenië' },
        { href: 'https://www.wingie.fr/nl/flights/az-azerbaidjan/', title: 'Azerbeidzjan' },
        { href: 'https://www.wingie.fr/nl/flights/by-wit-rusland/', title: 'Wit-Rusland' },
        { href: 'https://www.wingie.fr/nl/flights/eg-egypte/', title: 'Egypte' },
        { href: 'https://www.wingie.fr/nl/flights/ge-georgie/', title: 'Georgië' },
        { href: 'https://www.wingie.fr/nl/flights/in-india/', title: 'India' },
      ],
    },
    {
      title: 'Populaire luchtvaartmaatschappijen',
      items: [
        { href: 'https://www.wingie.fr/nl/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
        { href: 'https://www.wingie.fr/nl/flights/airlines/pobeda/', title: 'Pobeda' },
        { href: 'https://www.wingie.fr/nl/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
        { href: 'https://www.wingie.fr/nl/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
        { href: 'https://www.wingie.fr/nl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
        { href: 'https://www.wingie.fr/nl/flights/airlines/utair/', title: 'Utair' },
      ],
    },
  ],
  'fr-ja': [
    {
      title: '人気の目的地',
      items: [
        { title: 'ラスベガス', href: 'https://www.wingie.fr/ja/flights/to-las-vegas/' },
        { title: 'シカゴ', href: 'https://www.wingie.fr/ja/flights/to-chicago/' },
        { title: 'マイアミ', href: 'https://www.wingie.fr/ja/flights/to-miami/' },
        { title: 'カンクン', href: 'https://www.wingie.fr/ja/flights/to-cancun/' },
        { title: 'ロンドン', href: 'https://www.wingie.fr/ja/flights/to-london/' },
        { title: 'ホノルル', href: 'https://www.wingie.fr/ja/flights/to-honolulu/' },
      ],
    },
    {
      title: '人気の国',
      items: [
        { title: 'カナダ', href: 'https://www.wingie.fr/ja/flights/ca-canada/' },
        { title: '中国', href: 'https://www.wingie.fr/ja/flights/cn-china/' },
        { title: 'コスタリカ', href: 'https://www.wingie.fr/ja/flights/cr-costa-rica/' },
        { title: 'ドミニカ共和国', href: 'https://www.wingie.fr/ja/flights/do-dominican-republic/' },
        { title: 'エルサルバドル', href: 'https://www.wingie.fr/ja/flights/sv-el-salvador/' },
        { title: 'フランス', href: 'https://www.wingie.fr/ja/flights/fr-france/' },
      ],
    },
    {
      title: '人気の航空会社',
      items: [
        { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.fr/ja/flights/airlines/american-airlines/' },
        { title: 'デルタ航空', href: 'https://www.wingie.fr/ja/flights/airlines/delta-air-lines/' },
        { title: 'ユナイテッド航空', href: 'https://www.wingie.fr/ja/flights/airlines/united-airlines/' },
        { title: 'アラスカ航空', href: 'https://www.wingie.fr/ja/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/ja/flights/airlines/jetblue/' },
        { title: 'ハワイアン航空', href: 'https://www.wingie.fr/ja/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-zh': [
    {
      title: '热门目的地',
      items: [
        { title: '拉斯维加斯', href: 'https://www.wingie.fr/zh/flights/to-las-vegas/' },
        { title: '芝加哥', href: 'https://www.wingie.fr/zh/flights/to-chicago/' },
        { title: '迈阿密', href: 'https://www.wingie.fr/zh/flights/to-miami/' },
        { title: '坎昆', href: 'https://www.wingie.fr/zh/flights/to-cancun/' },
        { title: '伦敦', href: 'https://www.wingie.fr/zh/flights/to-london/' },
        { title: '火奴鲁鲁', href: 'https://www.wingie.fr/zh/flights/to-honolulu/' },
      ],
    },
    {
      title: '热门国家',
      items: [
        { title: '加拿大', href: 'https://www.wingie.fr/zh/flights/ca-canada/' },
        { title: '中国', href: 'https://www.wingie.fr/zh/flights/cn-china/' },
        { title: '哥斯达黎加', href: 'https://www.wingie.fr/zh/flights/cr-costa-rica/' },
        { title: '多米尼加共和国', href: 'https://www.wingie.fr/zh/flights/do-dominican-republic/' },
        { title: '萨尔瓦多', href: 'https://www.wingie.fr/zh/flights/sv-el-salvador/' },
        { title: '法国', href: 'https://www.wingie.fr/zh/flights/fr-france/' },
      ],
    },
    {
      title: '热门航空公司',
      items: [
        { title: '美国航空', href: 'https://www.wingie.fr/zh/flights/airlines/american-airlines/' },
        { title: '达美航空', href: 'https://www.wingie.fr/zh/flights/airlines/delta-air-lines/' },
        { title: '美联航', href: 'https://www.wingie.fr/zh/flights/airlines/united-airlines/' },
        { title: '阿拉斯加航空', href: 'https://www.wingie.fr/zh/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/zh/flights/airlines/jetblue/' },
        { title: '夏威夷航空', href: 'https://www.wingie.fr/zh/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-ko': [
    {
      title: '인기 목적지',
      items: [
        { title: '라스베이거스', href: 'https://www.wingie.fr/ko/flights/to-las-vegas/' },
        { title: '시카고', href: 'https://www.wingie.fr/ko/flights/to-chicago/' },
        { title: '마이애미', href: 'https://www.wingie.fr/ko/flights/to-miami/' },
        { title: '칸쿤', href: 'https://www.wingie.fr/ko/flights/to-cancun/' },
        { title: '런던', href: 'https://www.wingie.fr/ko/flights/to-london/' },
        { title: '호놀룰루', href: 'https://www.wingie.fr/ko/flights/to-honolulu/' },
      ],
    },
    {
      title: '인기 국가',
      items: [
        { title: '캐나다', href: 'https://www.wingie.fr/ko/flights/ca-canada/' },
        { title: '중국', href: 'https://www.wingie.fr/ko/flights/cn-china/' },
        { title: '코스타리카', href: 'https://www.wingie.fr/ko/flights/cr-costa-rica/' },
        { title: '도미니카 공화국', href: 'https://www.wingie.fr/ko/flights/do-dominican-republic/' },
        { title: '엘살바도르', href: 'https://www.wingie.fr/ko/flights/sv-el-salvador/' },
        { title: '프랑스', href: 'https://www.wingie.fr/ko/flights/fr-france/' },
      ],
    },
    {
      title: '인기 항공사',
      items: [
        { title: '아메리칸 항공', href: 'https://www.wingie.fr/ko/flights/airlines/american-airlines/' },
        { title: '델타 항공', href: 'https://www.wingie.fr/ko/flights/airlines/delta-air-lines/' },
        { title: '유나이티드 항공', href: 'https://www.wingie.fr/ko/flights/airlines/united-airlines/' },
        { title: '알래스카 항공', href: 'https://www.wingie.fr/ko/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/ko/flights/airlines/jetblue/' },
        { title: '하와이안 항공', href: 'https://www.wingie.fr/ko/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-hi': [
    {
      title: 'लोकप्रिय गंतव्य',
      items: [
        { title: 'लास वेगास', href: 'https://www.wingie.fr/hi/flights/to-las-vegas/' },
        { title: 'शिकागो', href: 'https://www.wingie.fr/hi/flights/to-chicago/' },
        { title: 'मियामी', href: 'https://www.wingie.fr/hi/flights/to-miami/' },
        { title: 'कैनकन', href: 'https://www.wingie.fr/hi/flights/to-cancun/' },
        { title: 'लंदन', href: 'https://www.wingie.fr/hi/flights/to-london/' },
        { title: 'होनोलुलु', href: 'https://www.wingie.fr/hi/flights/to-honolulu/' },
      ],
    },
    {
      title: 'लोकप्रिय देश',
      items: [
        { title: 'कनाडा', href: 'https://www.wingie.fr/hi/flights/ca-canada/' },
        { title: 'चीन', href: 'https://www.wingie.fr/hi/flights/cn-china/' },
        { title: 'कोस्टा रिका', href: 'https://www.wingie.fr/hi/flights/cr-costa-rica/' },
        { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.fr/hi/flights/do-dominican-republic/' },
        { title: 'अल सल्वाडोर', href: 'https://www.wingie.fr/hi/flights/sv-el-salvador/' },
        { title: 'फ्रांस', href: 'https://www.wingie.fr/hi/flights/fr-france/' },
      ],
    },
    {
      title: 'लोकप्रिय एयरलाइनें',
      items: [
        { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.fr/hi/flights/airlines/american-airlines/' },
        { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.fr/hi/flights/airlines/delta-air-lines/' },
        { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.fr/hi/flights/airlines/united-airlines/' },
        { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.fr/hi/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/hi/flights/airlines/jetblue/' },
        { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.fr/hi/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-ta': [
    {
      title: 'பிரபலமான இலக்குகள்',
      items: [
        { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.fr/ta/flights/to-las-vegas/' },
        { title: 'சிகாகோ', href: 'https://www.wingie.fr/ta/flights/to-chicago/' },
        { title: 'மியாமி', href: 'https://www.wingie.fr/ta/flights/to-miami/' },
        { title: 'கான்கன்', href: 'https://www.wingie.fr/ta/flights/to-cancun/' },
        { title: 'லண்டன்', href: 'https://www.wingie.fr/ta/flights/to-london/' },
        { title: 'ஓனோலுலு', href: 'https://www.wingie.fr/ta/flights/to-honolulu/' },
      ],
    },
    {
      title: 'பிரபலமான நாடுகள்',
      items: [
        { title: 'கனடா', href: 'https://www.wingie.fr/ta/flights/ca-canada/' },
        { title: 'சீனா', href: 'https://www.wingie.fr/ta/flights/cn-china/' },
        { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.fr/ta/flights/cr-costa-rica/' },
        { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.fr/ta/flights/do-dominican-republic/' },
        { title: 'எல் சால்வடோர்', href: 'https://www.wingie.fr/ta/flights/sv-el-salvador/' },
        { title: 'பிரான்சு', href: 'https://www.wingie.fr/ta/flights/fr-france/' },
      ],
    },
    {
      title: 'பிரபலமான விமான நிறுவனங்கள்',
      items: [
        { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.fr/ta/flights/airlines/american-airlines/' },
        { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.fr/ta/flights/airlines/delta-air-lines/' },
        { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.fr/ta/flights/airlines/united-airlines/' },
        { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.fr/ta/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/ta/flights/airlines/jetblue/' },
        { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.fr/ta/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-th': [
    {
      title: 'จุดหมายยอดนิยม',
      items: [
        { title: 'ลาสเวกัส', href: 'https://www.wingie.fr/th/flights/to-las-vegas/' },
        { title: 'ชิคาโก', href: 'https://www.wingie.fr/th/flights/to-chicago/' },
        { title: 'ไมอามี', href: 'https://www.wingie.fr/th/flights/to-miami/' },
        { title: 'แคนคูน', href: 'https://www.wingie.fr/th/flights/to-cancun/' },
        { title: 'ลอนดอน', href: 'https://www.wingie.fr/th/flights/to-london/' },
        { title: 'โฮโนลูลู', href: 'https://www.wingie.fr/th/flights/to-honolulu/' },
      ],
    },
    {
      title: 'ประเทศยอดนิยม',
      items: [
        { title: 'แคนาดา', href: 'https://www.wingie.fr/th/flights/ca-canada/' },
        { title: 'จีน', href: 'https://www.wingie.fr/th/flights/cn-china/' },
        { title: 'คอสตาริกา', href: 'https://www.wingie.fr/th/flights/cr-costa-rica/' },
        { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.fr/th/flights/do-dominican-republic/' },
        { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.fr/th/flights/sv-el-salvador/' },
        { title: 'ฝรั่งเศส', href: 'https://www.wingie.fr/th/flights/fr-france/' },
      ],
    },
    {
      title: 'สายการบินยอดนิยม',
      items: [
        { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.fr/th/flights/airlines/american-airlines/' },
        { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.fr/th/flights/airlines/delta-air-lines/' },
        { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.fr/th/flights/airlines/united-airlines/' },
        { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.fr/th/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/th/flights/airlines/jetblue/' },
        { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.fr/th/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-ur': [
    {
      title: 'مشہور منزلیں',
      items: [
        { title: 'لاس ویگاس', href: 'https://www.wingie.fr/ur/flights/to-las-vegas/' },
        { title: 'شکاگو', href: 'https://www.wingie.fr/ur/flights/to-chicago/' },
        { title: 'میامی', href: 'https://www.wingie.fr/ur/flights/to-miami/' },
        { title: 'کینکن', href: 'https://www.wingie.fr/ur/flights/to-cancun/' },
        { title: 'لندن', href: 'https://www.wingie.fr/ur/flights/to-london/' },
        { title: 'ہونولولو', href: 'https://www.wingie.fr/ur/flights/to-honolulu/' },
      ],
    },
    {
      title: 'مشہور ممالک',
      items: [
        { title: 'کینیڈا', href: 'https://www.wingie.fr/ur/flights/ca-canada/' },
        { title: 'چین', href: 'https://www.wingie.fr/ur/flights/cn-china/' },
        { title: 'کوسٹا ریکا', href: 'https://www.wingie.fr/ur/flights/cr-costa-rica/' },
        { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.fr/ur/flights/do-dominican-republic/' },
        { title: 'ایل سیلواڈور', href: 'https://www.wingie.fr/ur/flights/sv-el-salvador/' },
        { title: 'فرانس', href: 'https://www.wingie.fr/ur/flights/fr-france/' },
      ],
    },
    {
      title: 'مشہور ایئر لائنز',
      items: [
        { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.fr/ur/flights/airlines/american-airlines/' },
        { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.fr/ur/flights/airlines/delta-air-lines/' },
        { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.fr/ur/flights/airlines/united-airlines/' },
        { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.fr/ur/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/ur/flights/airlines/jetblue/' },
        { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.fr/ur/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
  'fr-ka': [
    {
      title: 'პოპულარული მიმართულებები',
      items: [
        { title: 'ლას-ვეგასი', href: 'https://www.wingie.fr/ka/flights/to-las-vegas/' },
        { title: 'ჩიკაგო', href: 'https://www.wingie.fr/ka/flights/to-chicago/' },
        { title: 'მაიამი', href: 'https://www.wingie.fr/ka/flights/to-miami/' },
        { title: 'კანკუნი', href: 'https://www.wingie.fr/ka/flights/to-cancun/' },
        { title: 'ლონდონი', href: 'https://www.wingie.fr/ka/flights/to-london/' },
        { title: 'ჰონოლულუ', href: 'https://www.wingie.fr/ka/flights/to-honolulu/' },
      ],
    },
    {
      title: 'პოპულარული ქვეყნები',
      items: [
        { title: 'კანადა', href: 'https://www.wingie.fr/ka/flights/ca-canada/' },
        { title: 'ჩინეთი', href: 'https://www.wingie.fr/ka/flights/cn-china/' },
        { title: 'კოსტა-რიკა', href: 'https://www.wingie.fr/ka/flights/cr-costa-rica/' },
        { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.fr/ka/flights/do-dominican-republic/' },
        { title: 'სალვადორი', href: 'https://www.wingie.fr/ka/flights/sv-el-salvador/' },
        { title: 'საფრანგეთი', href: 'https://www.wingie.fr/ka/flights/fr-france/' },
      ],
    },
    {
      title: 'პოპულარული ავიაკომპანიები',
      items: [
        { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.fr/ka/flights/airlines/american-airlines/' },
        { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.fr/ka/flights/airlines/delta-air-lines/' },
        { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.fr/ka/flights/airlines/united-airlines/' },
        { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.fr/ka/flights/airlines/alaska-airlines/' },
        { title: 'JetBlue', href: 'https://www.wingie.fr/ka/flights/airlines/jetblue/' },
        { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.fr/ka/flights/airlines/hawaiian-airlines/' },
      ],
    },
  ],
}
